<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TMapGeofenceDisplay',
})
</script>
<template>
  <div :class="bem()">
    <div :class="bem('ins')" ref="mapRef" :style="{ height }" />
    <div :class="bem('ft')" v-if="areaVisible">
      <GeofenceArea
        v-for="(_, index) in paths"
        :key="index"
        :index="index"
        :editVisible="false"
        :delVisible="false"
        @click="handleZoomToPolygon(index)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup name="TMapGeofenceDisplay">
import { onMounted, ref, nextTick, toRef, watch } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { RS_CENTER_LNG_LAT } from '@/constant'
import GeofenceArea from './Area.vue'
import { useTMapBase } from '../useTMapBase'
import { useTMapGeofence } from '../useTMapGeofence'

const [_, bem] = createNamespace('TMapGeofenceDisplay')

/** 组件属性 */
const props = withDefaults(
  defineProps<{
    /** 地图高度 */
    height?: string
    /** 围栏数据（JSON格式的多边形数组） */
    value?: string
    areaVisible?: boolean
  }>(),
  {
    height: '400px',
    areaVisible: true
  }
)

const mapRef = ref<HTMLElement>()

// 使用基础地图 Hook
const { Map, initMap } = useTMapBase(mapRef, {
  center: RS_CENTER_LNG_LAT
})

// 使用地理围栏管理 Hook
const valueRef = toRef(props, 'value')
const { paths, syncPolygons, zoomToPolygon, zoomToFit } = useTMapGeofence(Map, valueRef)

/**
 * 地图居中到指定围栏
 */
const handleZoomToPolygon = (index: number) => {
  zoomToPolygon(index)
}

/**
 * 初始化围栏数据同步
 * 将围栏数据显示在地图上
 */
const handlePathsChange = () => {
  syncPolygons(paths.value, true)
  zoomToFit()
}

// 监听围栏数据变化
watch(() => props.value, handlePathsChange)

onMounted(() => {
  nextTick(() => {
    const mapIns = initMap()
    if (mapIns) {
      // 初始化围栏数据显示
      handlePathsChange()
    }
  })
})
</script>

<style lang="less">
@import '../index.less';

.t-map-geofence-display {
  .map-box();

  &__ft {
    display: flex;
    gap: @margin-sm;
    margin-top: @margin-xs;
  }
}
</style>
